import { translate } from '@vimeo/i18n-runtime';

/**
 * Convert bytes to formatted short form size string.
 * @example
 *     314027597 => 314MB
 *
 * @param  {integer} bytes
 * @param  {integer} digits
 *
 * @return {string}  Formatted size string
 */
export const bytesToSize = (bytes: number | null, digits = 0) => {
  if (bytes === null) return '';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];

  let i = 0;
  for (i = 0; bytes >= 1024 && i < 4; i++) {
    bytes /= 1024;
  }

  const unit = units[i];
  if ((unit === 'GB' || unit === 'TB') && bytes % 1 >= 0.1) {
    digits = 1;
  }

  switch (unit) {
    case 'B':
      return translate({
        singular: '{BYTE_SIZE}B',
        replacements: {
          BYTE_SIZE: bytes.toFixed(digits),
        },
      });
    case 'KB':
      return translate({
        singular: '{BYTE_SIZE}KB',
        replacements: {
          BYTE_SIZE: bytes.toFixed(digits),
        },
      });
    case 'MB':
      return translate({
        singular: '{BYTE_SIZE}MB',
        replacements: {
          BYTE_SIZE: bytes.toFixed(digits),
        },
      });
    case 'GB':
      return translate({
        singular: '{BYTE_SIZE}GB',
        replacements: {
          BYTE_SIZE: bytes.toFixed(digits),
        },
      });
    case 'TB':
      return translate({
        singular: '{BYTE_SIZE}TB',
        replacements: {
          BYTE_SIZE: bytes.toFixed(digits),
        },
      });
    default:
      return bytes;
  }
};
